import React, { useState } from 'react';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import { useTranslation } from 'react-i18next';
import NotificationsList from 'screens/settings/components/notificationsTab/components/notificationsList/NotificationsList';
import { CompactPageLayout } from 'common/components/compactPageLayout';
import styles from './AdminNotificationsList.module.scss'
import Button from 'common/components/button/Button';
import Loading from 'common/services/Loading';
import NotificationsService from 'api/notifications/NotificationsService';
import Logger from 'common/services/Logger';
import { LOGGER_LOG_TYPE } from 'Config';
import { useToasts } from 'react-toast-notifications';
import ReactTooltip from 'react-tooltip';
import QuestionYesNo from 'common/components/questionYesNo/QuestionYesNo';

const AdminNotificationsList = () => {
    const { t } = useTranslation();
    const { addToast } = useToasts();

    const [showSyncModal, setShowSyncModal] = useState<boolean>(false);

    const syncAdminNotifications = async () => {

        setShowSyncModal(false);
        try {
            Loading.show();
            await NotificationsService.syncAdminNotifications();
            addToast(t('common.messages.record_finish_success'), { appearance: 'success' });

            Loading.hide();

        } catch (error) {
            Logger.error(LOGGER_LOG_TYPE.REQUEST, `Couldn't syncronize admin notifications`, error);
            addToast(t('common.messages.record_finish_error'), { appearance: 'error' });
            Loading.hide();
        }
    };

    const onCancelSync = () => {
        setShowSyncModal(false);
    };

    return (
        <ScreenTitle title={t('menu.notifications_default')}>
            <CompactPageLayout title={t('menu.notifications_default') as string} headerButtons={<>
                    <div data-tip={t('notifications.sync_admin_notifications_message')}>
                        <Button onClick={() => setShowSyncModal(true)} style={{ padding: '0.5rem 1.8rem' }}>{t('notifications.sync_admin_notifications')}</Button>
                    </div>
                    <ReactTooltip />
                </>}>
                <div className={styles.content}>
                    <div className={styles.alert}>
                        {t('notifications.admin_notifications_helper')}
                    </div>
                    <NotificationsList isAdmin={true} />
                </div>
                <QuestionYesNo
                    onNo={onCancelSync}
                    onYes={syncAdminNotifications}
                    isVisible={showSyncModal}
                    message={t('notifications.confirm_sync_admin_notifications')} />
            </CompactPageLayout>
        </ScreenTitle >

    )
}

export default AdminNotificationsList;

